<template lang="pug">
    .cell-action-wrapper.overflow-initial
        input(type="checkbox" id="checkbox" :value="value" v-model="activeSharingList" @change="uiActivateSharing()")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { toNumber } from 'lodash'

export default {
    name: 'CellCheck',
    props: {
        clickOnCell: {
            type: Function,
            default: () => {}
        },
        data: {
            type: String,
            default: ''
        },
        fullData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {}
    },
    computed: {
        ...mapState('ui/settings', {
            activeSharing: state => state.sharing.activeSharing,
            sharingType: state => state.sharing.sharingType
        }),
        value() {
            return toNumber(this.fullData.id)
        },
        activeSharingList: {
            get() {
                return this.activeSharing
            },
            set() {}
        }
    },
    methods: {
        ...mapActions('ui/settings', ['setActiveSharingAction']),
        uiActivateSharing() {
            if (this.sharingType === 'taxonomies') {
                this.setActiveSharingAction({ sharingId: toNumber(this.fullData.id), currentStatus: this.fullData.wam_custom_taxonomy_sharing })
            } else if (this.sharingType === 'audiences') {
                this.setActiveSharingAction({ sharingId: toNumber(this.fullData.id), currentStatus: this.fullData.audience_sharing })
            }
        }
    }
}
</script>
